// extracted by mini-css-extract-plugin
module.exports = {"titleDescription":"collapsible_titleDescription__3yLyW","line":"collapsible_line__TCEbl","arrow":"collapsible_arrow__2Bn0V","open":"collapsible_open__3BeQR","trigger":"collapsible_trigger__3KaiQ"};
    if(module.hot) {
      // 1790670304363
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  